<template>
    <c-dialog ref="dialog" title="资产档案维修记录" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div class="m-detail-tag flex-center-cross">
                <label>{{detailData.asset_code}} | {{detailData.asset_name}}</label>
                <c-state dict="assetUseStatusDic" tag :value="detailData.current_status"></c-state>
            </div>
        </template>

        <div class="m-detail-box">
            <c-table ref="recordList" height="grow" :paging="true">
                <c-table-column label="维修单号" width="150">
                    <template #default="{data}">
                        <span>{{data.document_number}}</span>
                    </template>
                </c-table-column>

                <c-table-column label="送修人" width="120">
                    <template #default="{data}">
                        <span>{{data.sender_user_name}}</span>
                    </template>
                </c-table-column>

                <c-table-column label="送修时间" width="120">
                    <template #default="{data}">
                        <span>{{data.repair_time}}</span>
                    </template>
                </c-table-column>

                <c-table-column label="维修地址" width="180">
                    <template #default="{data}">
                        <span>{{data.repair_address}}</span>
                    </template>
                </c-table-column>

                <c-table-column label="维修内容" width="180">
                    <template #default="{data}">
                        <span>{{data.repair_summary}}</span>
                    </template>
                </c-table-column>

                <c-table-column label="备注" width="200">
                    <template #default="{data}">
                        <span>{{data.remark}}</span>
                    </template>
                </c-table-column>

                <c-table-column label="创建人" width="100">
                    <template #default="{data}">
                        <span>{{data.create_user_name}}</span>
                    </template>
                </c-table-column>

                <c-table-column label="创建时间" width="140">
                    <template #default="{data}">
                        <span>{{data.create_date||'-'}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        v-if="auth('b_asset_repair_view')"
                        type="button"
                        label="操作"
                        width="60"
                        button-limit="1"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_asset_repair_view')" icon="tf-view"
                                        @click="globalDialog('assetRepairRecordDetail', {props: {id: data.id}})">查看</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </div>
    </c-dialog>
</template>

<script>
export default {
    name: 'assetRepairRecordListDialog',
    props: {
        asset_id: [String, Number]
    },
    data() {
        return {
            detailData: {}
        }
    },
    methods: {
        /********搜索************/
        searchHandle(data){
            if (!data){
                data = {};
            }
            this.$refs.recordList.load({
                url: '/asset_repair_record/list',
                data,
                success: () => {}
            });
        },
        open(data) {
            this.detailData = data;
            this.detailData.asset_id = data.id;
            this.detailData.work_type_id = 16;
            console.log(this.detailData)
            this.searchHandle(this.detailData);
            this.$refs.dialog.open();
        }
    }
}
</script>